import { useAtomValue, useSetAtom } from 'jotai';
import {
  currentStepAtom,
  handleNextAtom,
  handlePrevAtom,
  hasNextAtom,
  hasPrevAtom,
  totalStepsAtom,
} from './atoms';

export const useSteps = () => {
  const currentStep = useAtomValue(currentStepAtom);
  const hasNext = useAtomValue(hasNextAtom);
  const hasPrev = useAtomValue(hasPrevAtom);
  const totalSteps = useAtomValue(totalStepsAtom);
  const setTotalSteps = useSetAtom(totalStepsAtom);
  const handlePrev = useSetAtom(handlePrevAtom);
  const handleNext = useSetAtom(handleNextAtom);

  return {
    currentStep,
    setTotalSteps,
    totalSteps,
    hasPrev,
    hasNext,
    handlePrev,
    handleNext,
  };
};
